import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import * as React from 'react';
import { LinearProgress, Tooltip, useTheme } from '@material-ui/core';
import Typography from '../Typography';
import styled from 'styled-components';
import { designTokens } from '../Theme.design-tokens';
var LinearProgressWrapper = styled.div.withConfig({
  displayName: "Meter__LinearProgressWrapper",
  componentId: "wrt8gf-0"
})(["display:block;width:144px;margin:0 0.5rem;"]);
var MeterWrapper = styled.div.withConfig({
  displayName: "Meter__MeterWrapper",
  componentId: "wrt8gf-1"
})(["display:flex;justify-content:center;align-items:center;"]);
var StyledLinearProgress = styled(function (props) {
  return /*#__PURE__*/React.createElement(LinearProgress, _extends({
    classes: {
      bar: 'bar'
    }
  }, props));
}).withConfig({
  displayName: "Meter__StyledLinearProgress",
  componentId: "wrt8gf-2"
})(["&&{height:8px;border-radius:5px;background-color:", ";}& .bar{border-radius:5px;background-color:", ";}"], designTokens.colors.gray100, function (_ref) {
  var $percentage = _ref.$percentage,
      $warningLimit = _ref.$warningLimit,
      $softLimit = _ref.$softLimit,
      $hardLimit = _ref.$hardLimit,
      $theme = _ref.$theme;

  if ($percentage < $warningLimit) {
    return $theme.palette.success.main;
  } else if ($percentage < $softLimit) {
    return $theme.palette.warning.main;
  } else if ($percentage < $hardLimit) {
    return $theme.palette.error.main;
  } else {
    return designTokens.colors.gray900;
  }
});
var StyledTooltip = styled(function (props) {
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    classes: {
      popper: props.className,
      tooltip: 'tooltip',
      arrow: 'arrow'
    }
  }, props));
}).withConfig({
  displayName: "Meter__StyledTooltip",
  componentId: "wrt8gf-3"
})(["& .tooltip{background-color:", ";color:", ";border-radius:4px;max-width:155px;padding:23px;box-shadow:0px 6px 10px rgba(0,0,0,0.14),0px 1px 18px rgba(0,0,0,0.12),0px 3px 5px rgba(0,0,0,0.2);}& .arrow{font-size:20px;color:", ";}"], designTokens.colors.white, designTokens.colors.black, designTokens.colors.white);

var Meter = function Meter(_ref2) {
  var e2e = _ref2.e2e,
      label = _ref2.label,
      total = _ref2.total,
      usage = _ref2.usage,
      warningThresholdPercentage = _ref2.warningThresholdPercentage,
      softLimitThresholdPercentage = _ref2.softLimitThresholdPercentage,
      hardLimitThresholdPercentage = _ref2.hardLimitThresholdPercentage,
      tooltipBody = _ref2.tooltipBody;
  var percentage = total === 0 ? 0 : Math.round(usage / total * 100);
  var value = percentage > 100 ? 100 : percentage;
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(MeterWrapper, null, label && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, label), /*#__PURE__*/React.createElement(LinearProgressWrapper, null, /*#__PURE__*/React.createElement(StyledTooltip, {
    arrow: true,
    placement: "bottom",
    title: tooltipBody ? tooltipBody : '',
    PopperProps: _objectSpread(_objectSpread({}, e2e && {
      'data-e2e': "".concat(e2e, "-tooltip")
    }), {}, {
      modifiers: {
        offset: {
          enabled: true,
          offset: "-".concat(theme.spacing(5), ", ").concat(theme.spacing(1))
        }
      }
    })
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledLinearProgress, _extends({
    variant: "determinate",
    value: value,
    $percentage: percentage,
    $warningLimit: warningThresholdPercentage,
    $softLimit: softLimitThresholdPercentage,
    $hardLimit: hardLimitThresholdPercentage,
    $theme: theme
  }, e2e && {
    'data-e2e': e2e
  }))))));
};

export default Meter;

try {
  Meter.__docgenInfo = {
    description: '',
    displayName: 'Meter',
    methods: [],
    props: {
      label: {
        defaultValue: null,
        description: '',
        name: 'label',
        required: true,
        type: {
          name: 'string'
        }
      },
      total: {
        defaultValue: null,
        description: '',
        name: 'total',
        required: true,
        type: {
          name: 'number'
        }
      },
      usage: {
        defaultValue: null,
        description: '',
        name: 'usage',
        required: true,
        type: {
          name: 'number'
        }
      },
      warningThresholdPercentage: {
        defaultValue: null,
        description: '',
        name: 'warningThresholdPercentage',
        required: true,
        type: {
          name: 'number'
        }
      },
      softLimitThresholdPercentage: {
        defaultValue: null,
        description: '',
        name: 'softLimitThresholdPercentage',
        required: true,
        type: {
          name: 'number'
        }
      },
      hardLimitThresholdPercentage: {
        defaultValue: null,
        description: '',
        name: 'hardLimitThresholdPercentage',
        required: true,
        type: {
          name: 'number'
        }
      },
      tooltipBody: {
        defaultValue: null,
        description: '',
        name: 'tooltipBody',
        required: false,
        type: {
          name: 'ReactNode'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map